export enum RouteEnum {
    notfound = '/*',
    root = '/',
    dashboard = '/dashboard',
    
    transactions= '/transactions',
    details='/transactions/:headerId',
    
    rawdata= '/rawdata',
    rawtransaction= '/rawdata/:headerId',

    updateTicket='/update/:headerId',
    correctTransaction = '/correct/:headerId',
    redirecting = '/redirecting',
    signout = '/signout',
    miconfiguration = '/miconfiguration',

    admin = '/admin',
    reportList = '/report/configure',
    configureReportNew = '/report/configure/new',
    configureReportEdit = '/report/configure/:reportId',
    viewReport = '/report/view/:reportId',
    generateReport = '/report/generate'
}
